module.exports = __webpack_public_path__ + "static/fonts/Arimo-Medium.d54ae6a.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/arimo/Arimo-Medium.ttf
// module id = 569
// module chunks = 9